import {makeAutoObservable} from 'mobx';
import * as Api from '@/utils/api/api';
import GoodsType from '@/enum/GoodsType';
import CollectEnum from '@/enum/CollectEnum';

class ShopStore {
    shopId = 0;
    pageSize = 16;
    pageNum = 1;
    type = 0;
    list = [];
    shopInfo = null;
    hasCollect = false;
    collectId = 0;
    refreshing = false;

    constructor() {
        makeAutoObservable(this)
    }

    async fetchInfo() {
        try {
            this.refreshing = false;
            const {pageNum, pageSize, shopId, type} = this;
            let pddShop = type === GoodsType.PDD;

            const {
                list,
                shopInfo,
                totalNum,
                collectId,
                hasCollect
            } = await Api.shopInfo({pageNum, pageSize, shopId, pddShop});

            this.list = list;
            this.shopInfo = shopInfo;
            this.collectId = collectId;
            this.hasCollect = hasCollect;
        } catch (error) {

        } finally {
            this.refreshing = true;
        }
    }

    async switchCollect() {
        try {
            const {hasCollect, collectId, shopId} = this;

            if (hasCollect) {
                await Api.cancelCollect({
                    collectId
                });
                this.hasCollect = false;
            } else {
                const {collectId: cid} = await Api.addCollect({
                    id: shopId,
                    type: CollectEnum.SHOP
                });

                this.hasCollect = true;
                this.collectId = cid;
            }
        } catch (error) {
        }
    }
}

const store = new ShopStore();

export default store;
